<template>
  <div class="LoginMenu">
    <LoginLabel class="title" @mouseup="toggleDropdown">
      {{ content.title }}
    </LoginLabel>
    <div v-if="content.entries" class="dropdownAnchor">
      <LoginDropdown :entries="content.entries" class="dropdown" />
    </div>
  </div>
</template>

<script>
import LoginDropdown from './LoginDropdown.vue'
import LoginLabel from './LoginLabel.vue'

export default {
  components: {
    LoginDropdown,
    LoginLabel
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showDropdown: false,
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown
    },
  },
}
</script>

<style scoped>

.title {
  display: block;
  padding: var(--spacing-4) 0;
  transition: color 0.15s;
  cursor: pointer;
}

.dropdownAnchor {
  position: relative;
}

.dropdown {
  display: none;
  position: absolute;
  left: calc(-1 * var(--spacing-7));
  top: 0;
  white-space: nowrap;
  z-index: 10;
}

.LoginMenu:hover .title {
  color: var(--brand-color);
}

.LoginMenu:hover .dropdown {
  display: block;
}
</style>
